import {Injectable, Inject} from 'ng-metadata/core';
import {HttpService} from '../../../../infra/httpRequest/http.service';
import appConfigModule from '../../../../appConfig/appConfig.module';
import {PrimoResponse} from '../../../../infra/dataStructures/PrimoResponses/ils.interface';
import { ConfigurationUtil } from '../../../../nddUtils/configurationUtil.service';

@Injectable()
export class OpacService {

	private opacBaseUrl;
	private requestsErrorCounter:number = 0;

	private _responseStatus: StatusMsg;

	//Default Paths. will be updated in constructor;
	private ilsServices;
    private servicesListIsLoading: boolean = true;
    public serviceListRequestInProgress: boolean = false;

	constructor(@Inject('restBaseURLs') private restBaseURLs :Object,
				@Inject('$http') private $http : ng.IHttpService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('$timeout') private $timeout : ng.ITimeoutService,
				private configurationUtil: ConfigurationUtil,
				private httpService:HttpService) {
		this.opacBaseUrl = restBaseURLs['opacBaseUrl'];

		this.ilsServices = {
			'services': {
				'path': this.opacBaseUrl,
				'method': 'GET'
			},
			'locations': {
				'path': this.restBaseURLs['ILSServicesBaseURL'] + '/holdings',
				'method': 'POST'
			},
			'requests': {
				'path': '',
				'method': 'GET'
			}
		};


	}

	/* getters / setters */
	get responseStatus() {
		return this._responseStatus;
	}

	set responseStatus(responseStatus) {
		this._responseStatus = responseStatus;
	}

	public getResponseMessage(){
		if(this.responseStatus && this.responseStatus.msg === 'ok'){
			if(this.configurationUtil.isSuprima){
				return 'nui.request.success';
			} else {
				return 'Your request was successfully placed';
			}
		} else if(this.responseStatus) {
			return this.responseStatus.msg;
		}
	}

	public getServices(){
		return this.ilsServices;
	}

	public updateService(name, service) {
		this.ilsServices[name] = service;
	}

	public makeIlsRequest(serviceName: string, parmas: Object = null, method: string = null, suffixPath:string = ''){
		let serviceDetails = this.ilsServices[serviceName];
       
         suffixPath += (suffixPath ? '&' : '?')+'lang='+this.$translate.use();
		let httpConfig = {
			method: method || serviceDetails.method,
			url: serviceDetails.path + suffixPath,
			params: serviceDetails.method === 'GET' ? parmas : null,
			data: serviceDetails.method === 'POST' ? parmas : null
		};
        if(serviceName === 'services'){
            this.servicesListIsLoading = false;
        }
		return this.$http(httpConfig)
			.then(
				(response)=> this.ilsRequestSuccess(response.data),
				(error)=>this.ilsRequestFailure(error, serviceName, parmas)
            )
            .finally(() => {
                if(serviceName === 'services'){
                    this.servicesListIsLoading = true;
                }
            });
	}



	public makeIlsCall(service:PrimoResponse.Ils.IRequestService,
						  params: Object = null,
						  method: string = 'GET'){


		return this.httpService.call(method, service['link-to-service'], params);
	}


	public getIlsServicesList(ilsApiId, recInst, physicalServiceId, displayGetitOtherSpinner = false) {
        let service = this.ilsServices.services;
        service.path = this.opacBaseUrl + '/'+ilsApiId;
        if (physicalServiceId) {
            service.path = service.path + '/svcId/'+physicalServiceId;
        }
        this.updateService('services', service);
        let params;
        if (recInst) {
            params = {
                    'record-institution': recInst
            };
        }
        this.serviceListRequestInProgress = displayGetitOtherSpinner;
        return this.makeIlsRequest('services',params, '')
			.finally(()=>{this.serviceListRequestInProgress = false;});
    }

    public isServicesListIsLoadingDone() {
        return this.servicesListIsLoading;
    }

	private ilsRequestSuccess(response){
		this.requestsErrorCounter = 0;
		return response;
	}

	private ilsRequestFailure(reason, serviceName, params){
		this.requestsErrorCounter ++;
		if(this.requestsErrorCounter < 3 ){

			return this.$timeout(() => this.makeIlsRequest(serviceName, params, ''), 2000);
		}
		throw reason;
	}
}

export class StatusMsg {
	public isSuccess:boolean;
	public msg: string;

	constructor(isSuccess:boolean, msg:string){
		this.isSuccess = isSuccess;
		this.msg = msg;
	}
}
export default [ appConfigModule.name ];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/opac.service.ts